import { createFileRoute } from '@tanstack/react-router'

import CreateApbnApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/_create/containers/CreateApbnApbdPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/apbn/create/')({
  component: () => <CreateApbnApbdPage type="APBN" />
})
